import {
  Verified,
  Request,
  OnVerification,
  Prohibited,
} from 'components/Common/Icons/CompanyStatus'
import { VERIFIED, PROHIBITED, REQUEST } from 'utils/consts/companyStatus'
import { FC } from 'react'

export type CompanyVerificationStatus =
  | typeof VERIFIED
  | typeof REQUEST
  | typeof PROHIBITED

interface CompanyStatusIconProps {
  status: CompanyVerificationStatus
  size?: number
}

const status_icon = {
  [VERIFIED]: Verified,
  [REQUEST]: Request,
  [PROHIBITED]: Prohibited,
}

const CompanyStatusIcon: FC<CompanyStatusIconProps> = ({
  status,
  size = 20,
}) => {
  const Icon = status_icon[status] || OnVerification
  return <Icon size={size} />
}

export default CompanyStatusIcon
